const { createSlice } = require('@reduxjs/toolkit');
export const storeData = async (key, value) => {
	try {
		const jsonValue = JSON.stringify(value);
		sessionStorage.setItem(`${key}`, jsonValue);
	} catch (e) {
		// saving error
	}
};
const UiReducer = createSlice({
	name: 'ui',
	initialState: {
		loginmodal: false,
		arrival: null,
		depart: null,
		onwardFlight: null,
		returnFlight: null,
		tab: 'oneway',
		topTab: 'flight',
		busDepart: null,
		busArr: null,
		tripid: null,
		modal: false,
		holdes: null,
	},
	reducers: {
		toggleLoginScreen(state, action) {
			state.loginmodal = action.payload;
		},
		setSelectedArrival(state, action) {
			state.arrival = action.payload;
		},
		setSelectedDepart(state, action) {
			state.depart = action.payload;
		},
		setSelectedOnwardFlight(state, action) {
			state.onwardFlight = action.payload;
		},
		setSelectedReturnFlight(state, action) {
			state.returnFlight = action.payload;
		},
		setTab(state, action) {
			state.tab = action.payload;
		},
		setTopTab(state, action) {
			state.topTab = action.payload;
		},
		setSelectedBusDepart(state, action) {
			state.busDepart = action.payload;
		},
		setSelectedBusArr(state, action) {
			state.busArr = action.payload;
		},
		setSelectedTripID(state, action) {
			state.tripid = action.payload;
		},
		setModal(state, action) {
			state.modal = action.payload;
		},
		setHolidayDes(state, action) {
			state.holdes = action.payload;
		},
	},
});

const { actions } = UiReducer;

export const {
	toggleLoginScreen,
	setSelectedArrival,
	setSelectedDepart,
	setSelectedOnwardFlight,
	setSelectedReturnFlight,
	setTab,
	setTopTab,
	setSelectedBusDepart,
	setSelectedBusArr,
	setSelectedTripID,
	setModal,
	setHolidayDes,
} = actions;

export default UiReducer;
